<template>
    <div class="previewWrapper">
        <div class="fileSelector left"
            v-if="!previews[0]">
            <input class="fileUploadOriginal"
                accept="image/jpeg"
                type="file"
                name="file"
                id="file"
                tabindex="-1"
                @change="uploadFile($event, 'left')"/>
            <label class="fileUpload"
                for="file"
                tabindex="0">
                <div class="fileUploadContent">
                    <div class="fileUploadLabel">
                        <Icon class="addFileIcon"
                            icon="add_photo_alternate"/>
                        Add left image
                    </div>
                </div>
            </label>
        </div>
        <img class="leftImage"
            v-else
            :src="previews[0]"/>
        <div class="fileSelector right"
            v-if="!previews[1]">
            <input class="fileUploadOriginal"
                accept="image/jpeg"
                type="file"
                name="file"
                id="file"
                tabindex="-1"
                @change="uploadFile($event, 'right')"/>
            <label class="fileUpload"
                for="file"
                tabindex="0">
                <div class="fileUploadContent">
                    <div class="fileUploadLabel">
                        <Icon class="addFileIcon"
                            icon="add_photo_alternate"/>
                        Add right image
                    </div>
                </div>
            </label>
        </div>
        <img class="rightImage"
            v-else
            :src="previews[1]"/>
        <div class="divider"></div>
    </div>
</template>

<script>
    export default {
        name: 'SliderMedia',
        props: {
            previews: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                currentTime: new Date().getTime(),
                payload: {
                    files: [],
                    filePaths: []
                }
            }
        },
        methods: {
            async uploadFile(e, sequence) {
                var files = e.target.files || e.dataTransfer.files
                if(!files.length) {
                    return
                } else {
                    await this.createPreview(files[0], sequence)
                    var file = files[0]
                    var filePath = 'users/' + this.auth.id + '/entries/' + this.currentTime.toString() + '/' + file.name.replace(/\.[^/.]+$/, "") + '_' + sequence
                    this.payload.files.push(file)
                    this.payload.filePaths.push(filePath)

                    this.$emit('updatePayload', this.payload)
                }
            },
            createPreview(file, sequence) {
                var reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = (e) => {
                    var image = e.target.result
                    this.previews.push(image)

                    if(this.previews.length === 1) {
                    // only the cover needs to be generated
                        const img = new Image()
                        img.src = image
                        img.onload = () => {
                            if(img.width < img.height) {
                                this.coverImageRatio = 'portrait'
                            } else {
                                this.coverImageRatio = 'landscape'
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .previewWrapper {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        overflow: hidden;
    }

    .fileUpload, .previewWrapper {
        min-height: 28rem;
        max-height: 28rem;
    }

    .fileSelector {
        position: absolute;
        width: 50%;
        top: 0;
        height: 100%;
    }

    .left {
        left: 0;
    }

    .right {
        right: 0;
    }

    .fileUpload {
        border-radius: 0;
        width: 100%;
        min-height: 100%;
        z-index: 1;
    }

    .divider {
        position: absolute;
        top: 0;
        left: 50%;
        width: 1px;
        height: 100%;
        background: var(--color-white-important);
    }

    .leftImage, .rightImage {
        height: 28rem;
        object-fit: cover;
    }

    .leftImage {
        display: block;
        width: 100%;
    }

    .rightImage {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
        width: 100%;
        clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 100%);
    }
</style>